import * as React from "react";
import {
  TextField,
  InputLabel,
  Button,
  Stack,
  InputAdornment,
  autocompleteClasses,
  Popper,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import { SHEDULES, CATEGORY, FORM_TYPE, ROLE_USE } from "../../data/dummy-data";
import { useDispatch, useSelector } from "react-redux";
import {
  createFormTemplate,
  getAllFormTemplate,
  updateFormTemplate,
} from "../../store/formTemplate";
import { getAllUnit } from "../../store/njesiRaportuese";
import { setLoading } from "../../store/loading";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import SelectAutocomplate from "../UI/SelectAutocomplate";

const FormTemplateModalEditor = (props) => {
  const { njesiRaportuese } = useSelector((state) => state.njesiRaportuese);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  const { data, isstatusnew } = props;
  const [state, setState] = React.useState({
    name: "",
    description: "",
    schedule: "",
    type: "",
    reportingUnit: "",
    role: "",
  });

  const searchShedulesState = React.useRef("");
  const searchTypeState = React.useRef("");
  const searchRoleState = React.useRef("");
  const searchReportingUnitState = React.useRef("");
  const [searchValueServer, setSearchValueServer] = React.useState("");
  const [anchorElShedules, setAnchorElShedules] = React.useState(null);
  const [anchorElRole, setAnchorElRole] = React.useState(null);
  const [anchorElType, setAnchorElType] = React.useState(null);
  const [anchorElReportingUnit, setAnchorElReportingUnit] =
    React.useState(null);
  const [errorValues, setErrorValues] = React.useState([]);

  const handleClickShedules = (event) => {
    setAnchorElShedules(event.currentTarget);
  };

  const handleCloseShedules = () => {
    setAnchorElShedules(null);
  };

  const handleClickType = (event) => {
    setAnchorElType(event.currentTarget);
  };

  const handleCloseType = () => {
    setAnchorElType(null);
  };

  const handleClickRole = (event) => {
    setAnchorElRole(event.currentTarget);
  };

  const handleCloseRole = () => {
    setAnchorElRole(null);
  };

  const handleClickReportingUnit = (event) => {
    dispatch(getAllUnit({ page: 0, searchValue: "" }));
    setAnchorElReportingUnit(event.currentTarget);
  };

  const handleCloseReportingUnit = () => {
    setAnchorElReportingUnit(null);
  };

  const openShedules = Boolean(anchorElShedules);
  const openType = Boolean(anchorElType);
  const openRole = Boolean(anchorElRole);
  const openReportingUnit = Boolean(anchorElReportingUnit);

  const searchItems = (e) => {};

  React.useEffect(() => {
    getAllData();
  }, [dispatch, searchValueServer]);
  React.useEffect(() => {
    setErrorValues([]);
    setState({
      name: "",
      description: "",
      schedule: "",
      type: "",
      reportingUnit: "",
      role: "",
    });
  }, [data]);

  const getAllData = () => {
    dispatch(setLoading(true));
    dispatch(
      getAllUnit({
        page: 0,
        searchValue: searchValueServer,
        size: 1000,
        filterSelect: true,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value ? value : "" });
  };

  const saveFormTemplate = () => {
    var initialError = [];
    Object.keys(state).map(function (key, index) {
      if (state[key] !== "" || Object.keys(state[key]).length !== 0) {
      } else {
        initialError.push(key);
      }
    });

    setErrorValues(initialError);

    if (initialError.length === 0) {
      if (isstatusnew) {
        const { id, ...newFormTemplate } = state;
        dispatch(createFormTemplate({ formTemplate: newFormTemplate }));
      } else {
        const { ...updateFormTemplateTemp } = state;
        dispatch(updateFormTemplate({ formTemplate: updateFormTemplateTemp }));
      }
      dispatch(getAllFormTemplate());
      props.onClose();
    }
  };
  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ModalUI {...props}>
      <Stack spacing={2}>
        <TextField
          name="name"
          autoComplete="off"
          id="name"
          variant="outlined"
          error={checkError("name")}
          helperText={
            checkError("name") ? "Titulli Formës është i detyruar" : null
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Titulli Formës</InputAdornment>
            ),
          }}
          value={state.name}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack spacing={2}>
        <TextField
          name="description"
          autoComplete="off"
          id="description"
          variant="outlined"
          multiline
          maxRows={2}
          error={checkError("description")}
          helperText={
            checkError("description") ? "Përshkrimi është i detyruar" : null
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Përshkrimi</InputAdornment>
            ),
          }}
          value={state.description}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack spacing={2}>
        <SelectAutocomplate
          name="schedule"
          id="schedule"
          label="Frekuenca"
          placeholder="Kërko Frekuence"
          noOptionsText="Nuk ka Frekuence"
          value={state?.schedule}
          onClick={handleClickShedules}
          source={SHEDULES}
          open={openShedules}
          anchorEl={anchorElShedules}
          onClickAway={handleCloseShedules}
          error={checkError("schedule")}
          helperText={
            checkError("schedule") ? "Frekuenc është e detyruar" : null
          }
          onClose={(event, reason) => {
            if (reason === "escape") {
              handleCloseShedules();
            }
          }}
          onChange={(event, newValue, reason) => {
            if (
              event.type === "keydown" &&
              event.key === "Backspace" &&
              reason === "removeOption"
            ) {
              return;
            }
            setState({
              ...state,
              schedule: newValue.id ? newValue.id : "",
            });
            handleCloseShedules();
          }}
          onchangesearch={searchItems}
          inputRef={searchShedulesState}
        ></SelectAutocomplate>
      </Stack>
      <Stack>
        <SelectAutocomplate
          name="type"
          id="type"
          label="Tipi"
          placeholder="Kërko Tipi"
          noOptionsText="Nuk ka Tipi"
          value={state?.type}
          onClick={handleClickType}
          source={FORM_TYPE}
          open={openType}
          anchorEl={anchorElType}
          onClickAway={handleCloseType}
          error={checkError("type")}
          helperText={checkError("type") ? "Tipi është e detyruar" : null}
          onClose={(event, reason) => {
            if (reason === "escape") {
              handleCloseShedules();
            }
          }}
          onChange={(event, newValue, reason) => {
            if (
              event.type === "keydown" &&
              event.key === "Backspace" &&
              reason === "removeOption"
            ) {
              return;
            }
            setState({
              ...state,
              type: newValue?.id ? newValue?.id : "",
            });
            handleCloseType();
          }}
          onchangesearch={searchItems}
          inputRef={searchTypeState}
        ></SelectAutocomplate>
      </Stack>

      <Stack>
        <SelectAutocomplate
          name="role"
          id="role"
          label="Roli Perdorimit"
          placeholder="Kërko Roli Perdorimit"
          noOptionsText="Nuk ka Roli Perdorimit"
          value={state?.role}
          onClick={handleClickRole}
          source={ROLE_USE}
          open={openRole}
          anchorEl={anchorElRole}
          onClickAway={handleCloseRole}
          error={checkError("role")}
          helperText={
            checkError("role") ? "Roli Perdorimit është e detyruar" : null
          }
          onClose={(event, reason) => {
            if (reason === "escape") {
              handleCloseRole();
            }
          }}
          onChange={(event, newValue, reason) => {
            if (
              event.type === "keydown" &&
              event.key === "Backspace" &&
              reason === "removeOption"
            ) {
              return;
            }
            if (newValue.id === "ROLE_OSHMA") {
              setState({
                ...state,
                reportingUnit: null,
                role: newValue.id ? newValue.id : "",
              });
            } else {
              setState({
                ...state,
                role: newValue.id ? newValue.id : "",
              });
            }
            handleCloseRole();
          }}
          onchangesearch={searchItems}
          inputRef={searchRoleState}
        ></SelectAutocomplate>
      </Stack>
      {state?.role === "ROLE_INPUTER" && (
        <Stack>
          <SelectAutocomplate
            name="reportingUnit"
            id="reportingUnit"
            label="Njesi Raportuese"
            placeholder="Kërko Njesi Raportuese"
            noOptionsText="Nuk ka Njesi Raportuese"
            value={state?.reportingUnit}
            onClick={handleClickReportingUnit}
            source={njesiRaportuese}
            open={openReportingUnit}
            anchorEl={anchorElReportingUnit}
            onClickAway={handleCloseReportingUnit}
            error={checkError("reportingUnit")}
            helperText={
              checkError("reportingUnit")
                ? "Njesi Raportuese është e detyruar"
                : null
            }
            onClose={(event, reason) => {
              if (reason === "escape") {
                handleCloseReportingUnit();
              }
            }}
            onChange={(event, newValue, reason) => {
              if (
                event.type === "keydown" &&
                event.key === "Backspace" &&
                reason === "removeOption"
              ) {
                return;
              }
              setState({
                ...state,
                reportingUnit: newValue.id ? newValue.id : "",
              });
              handleCloseReportingUnit();
            }}
            onchangesearch={searchItems}
            inputRef={searchReportingUnitState}
          ></SelectAutocomplate>
        </Stack>
      )}
      <Stack sx={{ display: "flex", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "primary.dark",
            display: "flex",
            marginTop: "40px",
          }}
          startIcon={<Save />}
          onClick={saveFormTemplate}
        >
          {isstatusnew ? "Shto" : "Ndrysho"}
        </Button>
      </Stack>
    </ModalUI>
  );
};

export default FormTemplateModalEditor;

const StyledAutocompletePopper = styled("div")(({ theme }) => ({
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: "none",
    margin: 0,
    color: "inherit",
    fontSize: 13,
  },
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    height: "200px",
    backgroundColor: theme.palette.mode === "light" ? "#fff" : "#1c2128",
    padding: 0,
    [`& .${autocompleteClasses.option}`]: {
      alignItems: "flex-start",
      padding: 8,
      minHeight: "60px",
      height: "auto",
      fontSize: "16px",
      alignItems: "center",
      borderBottom: `1px solid  ${
        theme.palette.mode === "light" ? " #eaecef" : "#30363d"
      }`,
      '&[aria-selected="true"]': {
        backgroundColor: "transparent",
      },
      '&[data-focus="true"], &[data-focus="true"][aria-selected="true"]': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  [`&.${autocompleteClasses.popperDisablePortal}`]: {
    position: "relative",
  },
}));

function PopperComponent(props) {
  const { disablePortal, anchorEl, open, ...other } = props;
  return <StyledAutocompletePopper {...other} />;
}

PopperComponent.propTypes = {
  anchorEl: PropTypes.any,
  disablePortal: PropTypes.bool,
  open: PropTypes.bool.isRequired,
};

const StyledPopper = styled(Popper)(({ theme }) => ({
  zIndex: 1,
  paddingBottom: "20px",
  border: `1px solid ${theme.palette.mode === "light" ? "#e1e4e8" : "#30363d"}`,
  boxShadow: `0 8px 24px ${
    theme.palette.mode === "light" ? "rgba(149, 157, 165, 0.2)" : "rgb(1, 4, 9)"
  }`,
  borderRadius: 6,
  width: 480,
  fontSize: 13,
  color: theme.palette.mode === "light" ? "#24292e" : "#c9d1d9",
  backgroundColor: theme.palette.mode === "light" ? "#fff" : "#1c2128",
}));
